// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-containers-CaseStudy----CaseStudy-module---hero---1T8yt","case-study":"src-containers-CaseStudy----CaseStudy-module---case-study---2p7Bi","heading":"src-containers-CaseStudy----CaseStudy-module---heading---1PnAv","intro":"src-containers-CaseStudy----CaseStudy-module---intro---1ApnA","products":"src-containers-CaseStudy----CaseStudy-module---products---2mnP-","productLink":"src-containers-CaseStudy----CaseStudy-module---productLink---2bY62","content":"src-containers-CaseStudy----CaseStudy-module---content---1gy0h"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CaseStudy/CaseStudy.module.scss
// module id = 1215
// module chunks = 153935816800649